import { MutationObserver } from "@tanstack/query-core";
import type { DeleteUserParams } from "api-contracts/rpc/delete-user";
import type { SaveProfileParams } from "api-contracts/rpc/save-profile";
import type { sendChangeEmailVerificationParams } from "api-contracts/rpc/send-change-email-verification";
import type { UpdateProfileParams } from "api-contracts/rpc/update-profile";
import { queryClient } from "ui-common/data-query-controller";
import { rpc } from "ui-common/services/rpc";

export const saveProfileMutation = new MutationObserver(queryClient, {
  mutationKey: ["saveProfile"],
  mutationFn: (params: SaveProfileParams) => rpc("saveProfile", params),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["profileData"] }),
});

export const updateProfileMutation = new MutationObserver(queryClient, {
  mutationKey: ["updateProfile"],
  mutationFn: (params: UpdateProfileParams) => rpc("updateProfile", params),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["updateProfile"] }),
});

export const sendChangeEmailVerificationlMutation = new MutationObserver(queryClient, {
  mutationKey: ["changeEmail"],
  mutationFn: (params: sendChangeEmailVerificationParams) => rpc("send-change-email-verification", params),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["changeEmail"] }),
});

export const deleteUserMutation = new MutationObserver(queryClient, {
  mutationKey: ["deleteUser"],
  mutationFn: (param: DeleteUserParams) => rpc("deleteUser", param),
  onSuccess: () => queryClient.invalidateQueries({ queryKey: ["deleteUser"] }),
});
